/*============================================
	Section Rollover Image Script 
============================================*/ 

$(document).ready(function() {

  var mainImageSlider =  $('.rollover-image__carousel');

  mainImageSlider.each(function() {
    if ($(this).is(".carousel-slide__first")) {
      $(this).slick({
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        speed:2000,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
          loop: true
      });
    } 
    else if ($(this).is(".carousel-slide__alt")){
      $(this).slick({
        infinite: true,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed:4000,
        speed: 6000,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
          loop: true,
      });
    }
    else {
      $(this).slick();
    }
  });
   
   
   
  
});

